/* eslint-disable no-template-curly-in-string */
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Button, Modal, Header, Form, Icon, Message } from 'semantic-ui-react';

function defaultState({ category: { summary, detail, extra_data: extraData } = {} } = {}) {
  return {
    summary,
    detail,
    hide: !!extraData?.hide,
  };
}

export default class EditCategoryModal extends React.Component {
  state = defaultState(this.props)

  saveVariant = () => {
    const { category, onDismiss } = this.props;
    const { detail, summary, hide, sort } = this.state;
    this.setState({ loading: true, error: null }, async () => {
      const { status, body } = await fetchApi({
        url: `/loyalty/categories/edit/${category.display_category_id}`,
        body: { detail, summary, hide, sort },
      });
      if (status !== 200) {
        this.setState({ loading: false, error: body });
      } else {
        this.setState({ loading: false }, onDismiss);
      }
    });
  }

  render() {
    const { category, onDismiss } = this.props;
    const { detail, summary, error, loading, hide } = this.state;
    return (
      <Modal open>
        <Header content="Edit Category Mapping" />
        <Modal.Content>
          {error
            && (
            <Message error>
              Unable to edit category:
              <pre>{JSON.stringify(error, null, '\t')}</pre>
            </Message>
            )
          }
          <p>
            The raw category received from the affiliate network will be mapped
            to the summary (and optional detail popup) below. The summary should
            be simply text, but the detail can be markdown.
          </p>
          <Form loading={loading}>
            <Form.TextArea label="Source Category" readOnly>{category.source_category}</Form.TextArea>
            <Form.TextArea label="Summary" onChange={e => this.setState({ summary: e.target.value })}>{summary}</Form.TextArea>
            <Form.TextArea label="Detail" onChange={e => this.setState({ detail: e.target.value })}>{detail}</Form.TextArea>
            <Form.Checkbox
              label="Do not show this category in offer details (usually because the terms say the same)"
              onChange={(d, v) => this.setState({ hide: v.checked })}
              defaultChecked={hide}
            />
            <Form.Input label="Sort Order" placeholder="Lower number means higher in the list" type="number" onChange={e => this.setState({ sort: e.target.value })} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={onDismiss}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button basic color="red" onClick={this.saveVariant}>
            <Icon name="plus" />
            {' '}
            Update Category
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

EditCategoryModal.propTypes = {
  category: PT.shape({ affiliate_provider_id: PT.number, name: PT.string }),
  onDismiss: PT.func.isRequired,
};

EditCategoryModal.defaultProps = {
  category: null,
};
